// NOTE: rewritten due to the react hooks/rules of hooks lint rule
import { FormBlock } from '@qbe/ads-blocks-forms';
import { DatePicker, FormGroupLabel, Typography } from '@qbe/ads-core';
import React from 'react';

import { ContextualHelpWithButton } from '~/components-ds/ContextualHelp/ContextualHelpWithButton';
import { useAppContent, useAppDispatch, useBusinessDetails, useQuote } from '~/hooks';
import { updateCoverStart } from '~/slices/businessDetails';
import { updateAccessToken, updatePolicyNumber, updateQuoteNumber } from '~/slices/quote';
import { qalFormStartAction, qalTrackQuoteStartAction } from '~/thunks/analytics';
import { DateFormat } from '~/utils';
import { isFormStartStarted } from '~/utils/analytics/trackUtils';

const CoverStart: React.FC = () => {
  const currentDate = new Date();
  const expiryDateMax = new Date(currentDate);
  expiryDateMax.setDate(currentDate.getDate() + 30);
  const dispatch = useAppDispatch();
  const { coverStart } = useBusinessDetails();
  const { retrieveQuoteFlow } = useQuote();

  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.businessDetailsCoverStart',
  });

  /**
   * Using QAL quoteStart Milestone Flag
   */
  const quoteStartEngagement = () => {
    // QAL Quote Start - Deduplication happens in QAL
    if (!retrieveQuoteFlow) dispatch(qalTrackQuoteStartAction());
  };

  const handleFormStart = () => {
    if (!isFormStartStarted()) dispatch(qalFormStartAction());
  };

  return (
    <>
      <FormGroupLabel
        title={getTextContent('fields.dateInput.title')}
        alignCenter
        titleSuffix={
          <ContextualHelpWithButton tracking="help: when do you want cover to start">
            <Typography gutterBottom>
              {getJSXContent('contextualhelpers.dateInput.title')}
            </Typography>
            <Typography>{getJSXContent('contextualhelpers.dateInput.description')}</Typography>
          </ContextualHelpWithButton>
        }
      />

      <FormBlock preset="datetime" data-track="datePicker" data-track-value="capture">
        <DatePicker
          label={getTextContent('fields.dateInput.label')}
          id="coverStart"
          aria-labelledby="coverStart"
          data-track="starting date"
          date-track-value="capture"
          data-testid="cover-start__date-field"
          value={coverStart ? new Date(JSON.parse(coverStart)) : currentDate}
          name="coverStart"
          format={DateFormat.ddMMyyyy}
          maxDate={expiryDateMax}
          minDate={currentDate}
          helperText={getTextContent('fields.dateInput.helperText')}
          onChange={(
            selectedDate: React.SetStateAction<Date | null> /** TODO: Need to verify */
          ) => {
            dispatch(updateQuoteNumber(null));
            dispatch(updatePolicyNumber(null));
            dispatch(updateAccessToken(null));
            dispatch(updateCoverStart(JSON.stringify(selectedDate)));
            handleFormStart();
            quoteStartEngagement();
          }}
        />
      </FormBlock>
    </>
  );
};

export default CoverStart;
